import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import { formatDate, creatDownload } from '@/utils/formUtils'
import {
  compare,
  getdayType,
  cycleChange
} from 'enumeration/lab-order.js'
import orderDatas from '@/store/actions/datas/order'
import { sampleType } from 'json/goods-order-options'
import { getEnumeration } from 'enumeration'
import orderflowHelper from '@/config/order'
import { getPlateType } from '@/utils/plateType'
export default {
  getLabProductList (ctx, data) {
    return fetch.getLabProductList(data).then(res => {
      res.data.forEach(ele => {
        ele.changeCycle = ele.testCycle && ele.testCycle.replace(/[^0-9]/ig, '') + getdayType(ele.dayType)
        ele.examBasis = ele.examBasis || {}
      })
      return getTotalNumber(res)
    })
  },
  labProductAdd (ctx, data) {
    return fetch.labProductAdd(data).then(res => {
      return res
    })
  },
  updateLabProduct (ctx, data) {
    return fetch.updateLabProduct(data).then(res => {
      return res
    })
  },
  getLabProduct (ctx, id) {
    return fetch.getLabProduct(id).then(res => {
      return res.data
    })
  },
  deleteLabProduct (ctx, id) {
    return fetch.deleteLabProduct(id).then(res => {
      return res.data
    })
  },
  getMethodList (ctx) {
    return fetch.getMethodList().then(res => {
      return getTotalNumber(res)
    })
  }
}
